/* 🔧 Theme Sauce — buzzwoo E-Com Kitchen
 * Bodnik · Bow Type Comparison · Multi-image card carousel
 *
 * Tiny custom element. Mirrors Ignite's <modal-opener> idiom
 * (assets/global.js, ~30 LOC) — we deliberately do NOT reuse
 * <slider-component> here (that's 650 LOC and built for full-section
 * sliders). Card-internal swipe is dead simple with native CSS
 * scroll-snap; we only need JS for the dot active-state sync.
 */
class BwBowCardCarousel extends HTMLElement {
  connectedCallback() {
    const rail = this.querySelector('.bw-bow-type-comparison__image-list');
    if (!rail) return;

    const slides = Array.from(rail.querySelectorAll('.bw-bow-type-comparison__image-slide'));
    const dots = Array.from(this.querySelectorAll('.bw-bow-type-comparison__dot'));
    if (slides.length < 2 || dots.length !== slides.length) return;

    const setActive = (idx) => {
      dots.forEach((dot, i) => {
        const isActive = i === idx;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries
          .filter((entry) => entry.isIntersecting)
          .forEach((entry) => {
            const idx = slides.indexOf(entry.target);
            if (idx !== -1) setActive(idx);
          });
      },
      { root: rail, threshold: 0.6 }
    );

    slides.forEach((slide) => io.observe(slide));

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  }
}

if (!customElements.get('bw-bow-card-carousel')) {
  customElements.define('bw-bow-card-carousel', BwBowCardCarousel);
}
